var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
let TextNodeInput = class TextNodeInput extends LitElement {
    onInputChange(event) {
        const inputElement = event.target;
        // Met à jour la propriété input avec la nouvelle valeur
        this.input.value = String(inputElement.value);
        // Déclenche l'événement personnalisé avec la nouvelle valeur de input
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: { key: this.key, input: this.input },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
            <input-text
                .value=${this.input?.value || ''}
                .placeholder=${this.input?.placeholder || msg('Enter text', { id: 'nodeInput.placeholder.enterText', desc: 'Text node input placeholder' })}
                @input-text=${this.onInputChange}
            ></input-text>
        `;
    }
};
TextNodeInput.styles = css `
      .text-node-input {
        width: 100%;
        padding: 6px 9px; /* Réduction de 25% */
        font-size: 10.5px; /* Réduction de 25% */
        border: 1px solid #ccc;
        border-radius: 3px; /* Réduction de 25% */
        box-sizing: border-box;
        transition: border-color 0.3s ease, box-shadow 0.3s ease;
      }

      .text-node-input:focus {
        border-color: #555ab9;
        box-shadow: 0 0 3px rgba(85, 90, 185, 0.5); /* Réduction de 25% */
        outline: none;
      }

      .text-node-input::placeholder {
        color: #aaa;
        font-style: italic;
      }
    `;
__decorate([
    property({ type: String })
], TextNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], TextNodeInput.prototype, "input", void 0);
TextNodeInput = __decorate([
    localized(),
    customElement('text-node-input')
], TextNodeInput);
export { TextNodeInput };
//# sourceMappingURL=TextNodeInput.js.map